import React from "react";
// import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  // Link,
  // Navigate,
} from "react-router-dom";
// import {
//   Navbar,
//   Nav,
//   // NavItem,
//   // NavLink,
//   // Dropdown,
//   Container,
// } from "react-bootstrap";
import Barbora from "../../pages/Barbora";
import FoodSearch from "../../pages/FoodSearch";
import Home from "../../pages/Home";
import Users from "../../pages/Users";
import Fridge from "../../pages/Fridge";
import NotFoundPage from "../../pages/errors/NotFoundPage";
import Terms from "../../pages/Terms";
import Privacy from "../../pages/Privacy";
import LoginComponent from "../users/login/LoginComponent";
import { fetchLoggedInUser } from "../api/AuthService";
import logo from "../../resources/logo.png";
import UserService from "../users/service/UserService";
import { Trans } from "react-i18next";
import i18n from "./../../i18n";
import Navbar from "./Navbar";

// import PageView from "../wp/pageView";
import PostList from "../wp/PostList";
import PostView from "../wp/PostView";
import Search from "../wp/Autocomplete";

import data from "../wp/_setup.json";
import CategoryList from "../wp/CategoryList";
import CategoryView from "../wp/CategoryView";
import CollectionView from "../wp/CollectionView";
import CollectionsList from "../wp/CollectionsList";
import Contacts from "../../pages/Contacts";

import SearchResultsPage from "../wp/SearchResultsPage";
import TagList from "../wp/TagList";
import TagView from "../wp/TagView";

// const lngs = {
//   en: { nativeName: "EN" },
//   lt: { nativeName: "LT" },
// };

i18n.init({ lng: "en" });

class RouterComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isDataLoading: false,
      firstTime: false,
      amount: "",
    };
  }

  clearCart = () => {
    this.setState({ isDataLoading: true });
    if (this.state.isDataLoading) {
      UserService.cleanBarboraCart(this.state.data.id)
        .then(() => {
          this.setState({ isDataLoading: false });
          this.setState({
            amount: "Cleaned",
          });
          window.location.reload(true);
        })
        .catch((err) => {
          this.setState({ isDataLoading: false });
          console.log(err);
        });
    }
  };
// UNCOMMENT WHEN USING BARBORA API
  // componentDidMount() {
  //   {
  //     process.env.REACT_APP_PRODUCT_LAUNCH === "true" &&
  //       fetchLoggedInUser()
  //         .then((response) => {
  //           this.setState({ data: response.data });
  //           this.setState({ isDataLoading: false });

  //           response.data.checkoutAmount &&
  //             this.setState({
  //               amount: /\d{1,2}[,.]{1}\d{1,2}/.exec(
  //                 response.data.checkoutAmount.replace(",", ".")
  //               ),
  //             });

  //           //SESSION USER STORAGE
  //           sessionStorage.setItem("userData", JSON.stringify(response.data));
  //         })
  //         .catch((e) => {
  //           // console.log("error", e);
  //           this.setState({ isDataLoading: false });
  //         });
  //   }
  // }

  logOut = () => {
    localStorage.clear();
    // sessionStorage.clear();
  };

  render() {
    return (
      <div>
        {/* 2025 removed old navbar */}
        <Router>
          <Navbar userData={this.state.data} onLogout={this.logOut} />
          <Routes>
            <Route
              exact
              path="/"
              element={
                <Home
                  user={this.state.data.username}
                  firstTime={this.state.firstTime}
                />
              }
            ></Route>
            <Route path="/*" element={<NotFoundPage />}></Route>
            <Route path="/terms-and-conditions/" element={<Terms />}></Route>
            <Route path="/privacy-conditions/" element={<Privacy />}></Route>
            <Route path="/contacts/" element={<Contacts />}></Route>
            {/* Down are wp routes */}
            {/* Categories routes */}
            <Route
              path={
                "/" + data.url.slug_posts + "/" + data.url.slug_categories + "/"
              }
              element={<CategoryList />}
            ></Route>
            {/* Collection-style blog pages for categories (SEO friendly) */}
            <Route
              path={`/collections/`}
              element={<CollectionsList />}
            />
            <Route
              path={`/collections/:categoryName/`}
              element={<CollectionView />}
            />
            <Route
              path={`/${data.url.slug_posts}/${data.url.slug_categories}/page-:page`}
              element={<CategoryList />}
            ></Route>
            <Route
              path={
                "/" +
                data.url.slug_posts +
                "/" +
                data.url.slug_categories +
                "/:categoryName" +
                "/"
              }
              element={<CategoryView />}
            />
            <Route path={`/${data.url.slug_posts}/`} element={<PostList />} />
            <Route
              path={`/${data.url.slug_posts}/page-:page`}
              element={<PostList />}
            />
            <Route
              path={`/${data.url.slug_posts}/${data.url.slug_categories}/:categoryName`}
              element={<CategoryView />}
            />
            <Route
              path={`/${data.url.slug_posts}/${data.url.slug_categories}/:categoryName/page-:page`}
              element={<CategoryView />}
            />
            <Route
              path={`/${data.url.slug_posts}/tag/`}
              element={<TagView />}
            />
            <Route
              path={`/${data.url.slug_posts}/tag/:tagName`}
              element={<TagList />}
            />
            <Route
              path={`/${data.url.slug_posts}/tag/:tagName/page-:page`}
              element={<TagList />}
            />
            <Route path={`/search/:query`} element={<SearchResultsPage />} />
            <Route
              path={`/search/:query/page-:page`}
              element={<SearchResultsPage />}
            />
            <Route
              path={"/" + data.url.slug_posts + "/:postName/"}
              element={<PostView />}
            />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Router>
      </div>
    );
  }
}
export default RouterComponent;
